import type {ReactElement} from 'react';
import React from 'react';
import type {TurnIntoVideoTooltipProps} from './turn-into-video-tooltip.types';
import styles from './turn-into-video-tooltip.module.scss';
import {Text} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {Popover} from '@Components/popover';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';

export function TurnIntoVideoTooltip({referenceElementRef, onClose}: TurnIntoVideoTooltipProps): ReactElement {
  const videoSrc = getAssetUrl('ai-chat-create-a-video-tile.webm');

  return (
    <Popover
      referenceElementRef={referenceElementRef}
      popoverCloseFunction={onClose}
      alignment={PopoverDefaultAlignment.BOTTOM_CENTER}
      hasArrow
      staticOffsetForArrow={null}
      hasAutoPlacement={true}
      className={styles.tooltipPopover}
    >
      <div className={styles.tooltipContent}>
        <video src={videoSrc} className={styles.tooltipVideo} autoPlay loop muted playsInline />
        <Text val={window.i18next.t('pmwjs_create_a_video_sparkle')} className={styles.tooltipTitle} />
        <Text val={window.i18next.t('pmwjs_turn_design_into_engaging_video')} className={styles.tooltipSubtitle} />
      </div>
    </Popover>
  );
}
